import times from 'lodash/times'
import { lighten, darken } from '@material-ui/core/styles/colorManipulator'

export function getColorScale(
  color,
  countLight = 6,
  countDark = 5,
  coefficient = 0.1
) {
  return [
    ...times(countLight, i => lighten(color, (countLight - i) * coefficient)),
    color,
    ...times(countDark, i => darken(color, (i + 1) * coefficient))
  ]
}

export default getColorScale
